import Icon from '../components/Icon.vue'

Icon.register({
  spa: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M568.3 192c4.4 0 7.8 3.4 7.8 7.8-0.2 27.9-7.1 126.1-88.8 199.3-84 81.8-167.2 80.9-199.2 80.9s-115.2 0.9-199.2-80.9c-81.6-73.2-88.5-171.4-88.8-199.3 0-4.4 3.3-7.8 7.8-7.8 29 0.1 135 6.2 213.8 83 33.1 29.6 53.4 63.3 66.4 94.9 13-31.6 33.3-65.2 66.4-94.9 78.8-76.8 184.8-82.9 213.8-83zM288 302.6c-10.7-15.7-30.9-38.8-45-51.5-18.7-18.3-38.9-32.7-59.2-44.4 16.5-70.4 51.8-132.9 96.7-172.1 4.1-3.6 11-3.6 15.1 0 45 39.2 80.3 101.7 96.7 172.2-20.7 11.9-41.2 26.6-60.3 45.2-16.5 14.7-31.3 31.7-44.1 50.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/spa.js
// module id = 1933
// module chunks = 0